import { Component, Input } from '@angular/core';
import { IWizardContentComponent } from '../../../../wizard.content';

@Component({
  selector: 'nrwl-new.group.result',
  templateUrl: './new.user.group.result.component.html',
  styleUrls: ['./new.user.group.result.component.scss']
})
export class NewUserGroupResultComponent implements IWizardContentComponent {
  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  @Input() id: string;
  @Input() previousOutput: any;

  constructor() { }

  requestFailed() {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  returnErrorMessage() {
    return this.wizardCtrl.getWizardService().errorMessage;
  }

  returnSuccessMessage() {
    return this.wizardCtrl.getWizardService().successMessage;
  }

}
